import axios from 'axios'
import type { CreateMoodEntryRequest, MoodEntryDto, UpdateMoodEntryRequest } from '../Models/Mood'

const apimSubscriptionKey = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY

export const moodAxios = axios.create({
  baseURL: process.env.REACT_APP_MOOD_API_BASE_URL ?? 'http://localhost:7073/api',
  headers: {
    'Content-Type': 'application/json',
    ...(apimSubscriptionKey
      ? { 'Ocp-Apim-Subscription-Key': apimSubscriptionKey }
      : {}),
  },
})

export const moodApi = {
  getAll: () => moodAxios.get<MoodEntryDto[]>('/GetMoodEntries').then((r) => r.data),
  getByDate: (date: string) =>
    moodAxios.get<MoodEntryDto[]>(`/GetMoodEntriesByDate/${date}`).then((r) => r.data),
  create: (body: CreateMoodEntryRequest) =>
    moodAxios.post<MoodEntryDto>('/CreateMoodEntry', body).then((r) => r.data),
  update: (id: string, patch: UpdateMoodEntryRequest) =>
    moodAxios.patch<MoodEntryDto>(`/UpdateMoodEntry/${id}`, patch).then((r) => r.data),
  delete: (id: string) => moodAxios.delete(`/DeleteMoodEntry/${id}`),
}
